module.exports = __webpack_public_path__ + "static/extra_6_mobile-e0388fc03d5d648d6fdf605d2f2c0b24.jpg";